/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCLONEREASON } from './IAPCLONEREASON';
import {
    IAPCLONEREASONFromJSON,
    IAPCLONEREASONFromJSONTyped,
    IAPCLONEREASONToJSON,
} from './IAPCLONEREASON';
import type { IAPCURRENCY } from './IAPCURRENCY';
import {
    IAPCURRENCYFromJSON,
    IAPCURRENCYFromJSONTyped,
    IAPCURRENCYToJSON,
} from './IAPCURRENCY';
import type { IAPPROPOSALSTATUS } from './IAPPROPOSALSTATUS';
import {
    IAPPROPOSALSTATUSFromJSON,
    IAPPROPOSALSTATUSFromJSONTyped,
    IAPPROPOSALSTATUSToJSON,
} from './IAPPROPOSALSTATUS';
import type { IAPSIGNINGOPTIONS } from './IAPSIGNINGOPTIONS';
import {
    IAPSIGNINGOPTIONSFromJSON,
    IAPSIGNINGOPTIONSFromJSONTyped,
    IAPSIGNINGOPTIONSToJSON,
} from './IAPSIGNINGOPTIONS';
import type { IAPTRANSACTIONTYPE } from './IAPTRANSACTIONTYPE';
import {
    IAPTRANSACTIONTYPEFromJSON,
    IAPTRANSACTIONTYPEFromJSONTyped,
    IAPTRANSACTIONTYPEToJSON,
} from './IAPTRANSACTIONTYPE';
import type { PartyViewModel } from './PartyViewModel';
import {
    PartyViewModelFromJSON,
    PartyViewModelFromJSONTyped,
    PartyViewModelToJSON,
} from './PartyViewModel';

/**
 * 
 * @export
 * @interface ProposalViewModel
 */
export interface ProposalViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    partyId: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    selectedScenarioId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    clonedFromProposalNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProposalViewModel
     */
    dateCreated: Date;
    /**
     * 
     * @type {IAPPROPOSALSTATUS}
     * @memberof ProposalViewModel
     */
    status?: IAPPROPOSALSTATUS;
    /**
     * 
     * @type {Date}
     * @memberof ProposalViewModel
     */
    expiryDate: Date;
    /**
     * 
     * @type {IAPCURRENCY}
     * @memberof ProposalViewModel
     */
    currency?: IAPCURRENCY;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    sumOfInvestmentAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalViewModel
     */
    advancedGuarantee?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    clientName?: string;
    /**
     * 
     * @type {IAPCLONEREASON}
     * @memberof ProposalViewModel
     */
    cloneReason?: IAPCLONEREASON;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    quoteVersionNumber?: number;
    /**
     * 
     * @type {IAPSIGNINGOPTIONS}
     * @memberof ProposalViewModel
     */
    signingOptionId?: IAPSIGNINGOPTIONS;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    fSPName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    fSPNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    bankBrokerApplicationNumber?: string;
    /**
     * 
     * @type {IAPTRANSACTIONTYPE}
     * @memberof ProposalViewModel
     */
    transactionTypeId: IAPTRANSACTIONTYPE;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    intermediaryCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProposalViewModel
     */
    lastOpened?: Date;
    /**
     * 
     * @type {PartyViewModel}
     * @memberof ProposalViewModel
     */
    party?: PartyViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalViewModel
     */
    employerPartnership?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    employerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalViewModel
     */
    employeeNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalViewModel
     */
    employerSchemeId?: number;
}

/**
 * Check if a given object implements the ProposalViewModel interface.
 */
export function instanceOfProposalViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "expiryDate" in value;
    isInstance = isInstance && "transactionTypeId" in value;

    return isInstance;
}

export function ProposalViewModelFromJSON(json: any): ProposalViewModel {
    return ProposalViewModelFromJSONTyped(json, false);
}

export function ProposalViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'partyId': json['PartyId'],
        'selectedScenarioId': !exists(json, 'SelectedScenarioId') ? undefined : json['SelectedScenarioId'],
        'clonedFromProposalNumber': !exists(json, 'ClonedFromProposalNumber') ? undefined : json['ClonedFromProposalNumber'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'dateCreated': (new Date(json['DateCreated'])),
        'status': !exists(json, 'Status') ? undefined : IAPPROPOSALSTATUSFromJSON(json['Status']),
        'expiryDate': (new Date(json['ExpiryDate'])),
        'currency': !exists(json, 'Currency') ? undefined : IAPCURRENCYFromJSON(json['Currency']),
        'sumOfInvestmentAmount': !exists(json, 'SumOfInvestmentAmount') ? undefined : json['SumOfInvestmentAmount'],
        'advancedGuarantee': !exists(json, 'AdvancedGuarantee') ? undefined : json['AdvancedGuarantee'],
        'clientName': !exists(json, 'ClientName') ? undefined : json['ClientName'],
        'cloneReason': !exists(json, 'CloneReason') ? undefined : IAPCLONEREASONFromJSON(json['CloneReason']),
        'quoteVersionNumber': !exists(json, 'QuoteVersionNumber') ? undefined : json['QuoteVersionNumber'],
        'signingOptionId': !exists(json, 'SigningOptionId') ? undefined : IAPSIGNINGOPTIONSFromJSON(json['SigningOptionId']),
        'fSPName': !exists(json, 'FSPName') ? undefined : json['FSPName'],
        'fSPNumber': !exists(json, 'FSPNumber') ? undefined : json['FSPNumber'],
        'bankBrokerApplicationNumber': !exists(json, 'BankBrokerApplicationNumber') ? undefined : json['BankBrokerApplicationNumber'],
        'transactionTypeId': IAPTRANSACTIONTYPEFromJSON(json['TransactionTypeId']),
        'intermediaryCode': !exists(json, 'IntermediaryCode') ? undefined : json['IntermediaryCode'],
        'lastOpened': !exists(json, 'LastOpened') ? undefined : (new Date(json['LastOpened'])),
        'party': !exists(json, 'Party') ? undefined : PartyViewModelFromJSON(json['Party']),
        'employerPartnership': !exists(json, 'EmployerPartnership') ? undefined : json['EmployerPartnership'],
        'employerId': !exists(json, 'EmployerId') ? undefined : json['EmployerId'],
        'employeeNumber': !exists(json, 'EmployeeNumber') ? undefined : json['EmployeeNumber'],
        'employerSchemeId': !exists(json, 'EmployerSchemeId') ? undefined : json['EmployerSchemeId'],
    };
}

export function ProposalViewModelToJSON(value?: ProposalViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PartyId': value.partyId,
        'SelectedScenarioId': value.selectedScenarioId,
        'ClonedFromProposalNumber': value.clonedFromProposalNumber,
        'Description': value.description,
        'DateCreated': (value.dateCreated.toISOString()),
        'Status': IAPPROPOSALSTATUSToJSON(value.status),
        'ExpiryDate': (value.expiryDate.toISOString()),
        'Currency': IAPCURRENCYToJSON(value.currency),
        'SumOfInvestmentAmount': value.sumOfInvestmentAmount,
        'AdvancedGuarantee': value.advancedGuarantee,
        'ClientName': value.clientName,
        'CloneReason': IAPCLONEREASONToJSON(value.cloneReason),
        'QuoteVersionNumber': value.quoteVersionNumber,
        'SigningOptionId': IAPSIGNINGOPTIONSToJSON(value.signingOptionId),
        'FSPName': value.fSPName,
        'FSPNumber': value.fSPNumber,
        'BankBrokerApplicationNumber': value.bankBrokerApplicationNumber,
        'TransactionTypeId': IAPTRANSACTIONTYPEToJSON(value.transactionTypeId),
        'IntermediaryCode': value.intermediaryCode,
        'LastOpened': value.lastOpened === undefined ? undefined : (value.lastOpened.toISOString()),
        'Party': PartyViewModelToJSON(value.party),
        'EmployerPartnership': value.employerPartnership,
        'EmployerId': value.employerId,
        'EmployeeNumber': value.employeeNumber,
        'EmployerSchemeId': value.employerSchemeId,
    };
}

